import React, { useState } from 'react';
import { Fab, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChatIcon from '@material-ui/icons/Chat';
import { DevinChatDialog } from './DevinChatDialog';

const useStyles = makeStyles(theme => ({
  '@keyframes pulse': {
    '0%': {
      boxShadow: '0 0 0 0 rgba(63, 81, 181, 0.7)',
    },
    '70%': {
      boxShadow: '0 0 0 10px rgba(63, 81, 181, 0)',
    },
    '100%': {
      boxShadow: '0 0 0 0 rgba(63, 81, 181, 0)',
    },
  },
  container: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  fab: {
    width: 64,
    height: 64,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    animation: '$pulse 2s infinite',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
      animation: 'none',
    },
  },
  label: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  icon: {
    fontSize: 32,
  },
}));

export const DevinChatButton = () => {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [showLabel, setShowLabel] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Box
        className={classes.container}
        onMouseEnter={() => setShowLabel(true)}
        onMouseLeave={() => setShowLabel(false)}
      >
        {showLabel && (
          <Typography className={classes.label} variant="body2">
            Chat con Devin
          </Typography>
        )}
        <Fab
          className={classes.fab}
          color="secondary"
          aria-label="chat con devin"
          onClick={handleOpenDialog}
        >
          <ChatIcon className={classes.icon} />
        </Fab>
      </Box>

      <DevinChatDialog open={openDialog} onClose={handleCloseDialog} />
    </>
  );
};
